//initial redux
import { put, call, all, takeLatest, select, take } from "redux-saga/effects";
import reportservice from "../../../services/reports";
import { types as searchtypes } from "../../../components/SearchBar/redux";
import { types as sitetreetypes } from "../../../services/SiteTree/redux";
import { actions as reportactions } from "../../../ui/Rules/Reports/redux";

const initialState = {
    ruleInstancesList: [],
    selectedRuleInstance: {
        name: "",
        description: "",
        impact: "",
        possibleCauses: "",
    },
    isBusy: false,
    errors: [],
    hasError: false
};

/////////
//types
export const types = {
    SELECT_RULE_INSTANCE: "screens/rules/ruleinstance/SELECT_RULE_INSTANCE",
    LOAD_RULE_INSTANCE: "screens/rules/ruleinstance/LOAD_RULE_INSTANCE",
    GET_RULE_INSTANCES: "screens/rules/ruleinstance/GET_RULE_INSTANCES",
    RESET_STATE: "screens/rules/ruleinstance/RESET_STATE"
};

///////////
//reducers
export const reducers = {
    reducer(state = initialState, action) {
        switch (action.type) {
            case types.GET_RULE_INSTANCES: {
                return { ...state, ruleInstancesList: action.payload.ruleInstancesList };
            }
            case types.LOAD_RULE_INSTANCE: {
                return state;
            }
            case types.SELECT_RULE_INSTANCE: {
                return { ...state, selectedRuleInstance: action.payload.ruleInstance };
            }
            case types.RESET_STATE: 
                return initialState;
            default:
                return state;
        }
    }
};

//////////
//sagas
export const sagas = {
    *rootSaga() {
        yield all([this.selectRuleInstance(), this.loadRuleInstance(), this.onSearch()]);
    },
    *selectRuleInstance() {
        yield takeLatest(types.SELECT_RULE_INSTANCE, function* ({ payload }) {
            yield put(reportactions.getReport(payload.ruleInstance.ruleInstanceId));
        });
    },
    *loadRuleInstance() {
        yield takeLatest(types.LOAD_RULE_INSTANCE, function* ({ payload }) {
            const ruleInstance = yield call(reportservice.GetBasicRuleInstance, payload.ruleInstanceId);
            yield put(actions.selectRuleInstance(ruleInstance));
        });
    },
    *onSearch() {
        yield takeLatest(
            [searchtypes.SEARCH_BAR_UPDATED, searchtypes.SEARCH_BAR_SUBMIT],
            function* ({ payload }) {
                if (payload.searchBarId === "reports/ruleinstances") {
                    let currentSite = yield select(x => x.sitetree.currentSite);
                    if (!currentSite) {
                        const _action = yield take(sitetreetypes.ON_LOAD);
                        currentSite = _action.payload.currentSite;
                    }

                    const ruleInstances = yield call(reportservice.GetRuleInstances, currentSite.name, payload.query);
                    if (ruleInstances instanceof Error) {
                        console.error(ruleInstances);
                        yield put(
                            actions.genericAction(types.ON_GET_FRIENDS_FAILED, ruleInstances)
                        );
                    } else {
                        yield put(actions.getRuleInstances(ruleInstances));
                    }
                }
            }
        );
    },
};
////////
//actions
export const actions = {
    getRuleInstances(ruleInstancesList) {
        return {
            type: types.GET_RULE_INSTANCES,
            payload: { ruleInstancesList }
        };
    },
    selectRuleInstance(ruleInstance) {
        return {
            type: types.SELECT_RULE_INSTANCE,
            payload: { ruleInstance }
        };
    },
    loadRuleInstance(ruleInstanceId) {
        return {
            type: types.LOAD_RULE_INSTANCE,
            payload: { ruleInstanceId }
        };
    },
    onSearch() {
        return {
            type: searchtypes.SEARCH_BAR_UPDATED,
            payload: {
                searchBarId: "reports/ruleinstances",
                query: ""
            }
        }
    },
    resetState() {
        return {
            type: types.RESET_STATE
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/ReportComponents/RuleInstanceSearch/redux.js